module.exports = __webpack_public_path__ + "static/img/比亚迪易三方.210c6677.png";